import React, { useState, useEffect } from 'react';
import './VistaGeneral.css';

function fmt(n) {
  if (n === null || n === undefined) return '—';
  if (Math.abs(n) >= 1000000) return '€' + (n / 1000000).toFixed(2) + 'M';
  if (Math.abs(n) >= 1000) return '€' + Math.round(Math.abs(n) / 1000) + 'K';
  return '€' + Math.abs(n).toLocaleString('es-ES');
}

// Returns the date string as-is (BC dates are already "YYYY-MM-DD"), or "—" if empty
function fmtDate(val) {
  if (!val) return '—';
  return val;
}

function Skeleton() {
  return <span className="amt-skeleton" />;
}

const MOCK_PROJECTS = [
  {
    id: 'p1', name: 'Xilxes 1 - Burriana', type: 'PROJECT',
    paid: 118000, toBeCollected: 96000, collected: 79500, refundPaid: 30250, refundPending: 12000,
    paymentDate: 'Oct 2025', collectedDate: null,
    totalUnits: 12, soldUnits: 7,
    timeline: [
      { date: '05 Jun 2025', amount: 30000, desc: '1ª tanda · reserva inicial', status: 'Pagado' },
      { date: '25 Sep 2025', amount: 22000, desc: '2ª tanda · refuerzo comercialización', status: 'Pagado' },
      { date: '24 Oct 2025', amount: 66000, desc: '3ª tanda · cierre fase 1', status: 'Pagado' },
      { date: '15 Feb 2026', amount: 40000, desc: '4ª tanda · fase 2', status: 'Pendiente' },
      { date: 'Jun 2026', amount: 40000, desc: '5ª tanda · fase 3', status: 'Prevista' },
    ],
    desglose: {
      reserva: [
        { date: '05 Jun 2025', amount: 30000, desc: '1ª tanda reserva' },
        { date: '25 Sep 2025', amount: 22000, desc: '2ª tanda' },
        { date: '24 Oct 2025', amount: 66000, desc: '3ª tanda · cierre fase 1' },
      ],
      refunds: [
        { date: '12 Nov 2025', amount: 30250, desc: 'Transferencia refund · 3 clientes' },
      ]
    },
    units: [
      { id: 'v1', name: 'V1', client: 'Sergio Saiz García', uniqueId: 'SP-HRY-BGY-004764', address: 'C. Xilxes 1, V1, Burriana', toBeCollected: 8000, collected: 8000, collectedDate: '25 Sep 2025', status: 'Pagado', firmaEst: 'Sep 2025' },
      { id: 'v4', name: 'V4', client: 'Tomas Sanchez', uniqueId: 'SP-FDE-TBF-004646', address: 'C. Xilxes 1, V4', toBeCollected: 30250, collected: 8000, collectedDate: '08 Sep 2025', status: 'Parcial', firmaEst: 'Sep 2025' },
      { id: 'v6', name: 'V6', client: null, uniqueId: null, address: 'C. Xilxes 1, V6', toBeCollected: 8000, collected: 0, collectedDate: null, status: 'Sin cliente', firmaEst: null },
    ]
  },
  {
    id: 'p2', name: 'TR Toledo - Camarena', type: 'BUILDING',
    paid: 269000, toBeCollected: 218700, collected: 224000, refundPaid: 0, refundPending: 5300,
    paymentDate: 'Abr 2025', collectedDate: null,
    totalUnits: 22, soldUnits: 19,
    timeline: [
      { date: '28 Mar 2025', amount: 20000, desc: '1ª tanda · reserva', status: 'Pagado' },
      { date: '11 Abr 2025', amount: 123500, desc: '2ª tanda · cierre bloque A', status: 'Pagado' },
      { date: 'Mar 2026', amount: 80000, desc: '3ª tanda estimada · bloque B', status: 'Prevista' },
    ],
    desglose: {
      reserva: [
        { date: '28 Mar 2025', amount: 20000, desc: '1ª tanda reserva' },
        { date: '11 Abr 2025', amount: 123500, desc: '2ª tanda · cierre bloque A' },
      ],
      refunds: []
    },
    units: [
      { id: 'u1', name: 'Es:1 Pl:01 Pt:E', client: 'Andres Julian Joven', uniqueId: 'SP-3BH-2BH-003517', address: 'Tr. Toledo 4 Es:1 Pl:01, Camarena', toBeCollected: 10000, collected: 10000, collectedDate: '09 Abr 2025', status: 'Pagado', firmaEst: 'Abr 2025' },
      { id: 'u2', name: 'Es:2 Pl:00 Pt:A', client: null, uniqueId: null, address: 'TR Toledo 2 Es:2 Pl:00', toBeCollected: 10000, collected: 0, collectedDate: null, status: 'Sin cliente', firmaEst: null },
    ]
  },
  {
    id: 'p3', name: 'Serra - Core Capital', type: 'VP 10%',
    paid: 193000, toBeCollected: 139700, collected: 214000, refundPaid: 0, refundPending: 74000,
    paymentDate: 'Sep 2025', collectedDate: null,
    totalUnits: 13, soldUnits: 13,
    timeline: [
      { date: '05 Sep 2025', amount: 193000, desc: 'Pago único · reserva total del edificio', status: 'Pagado' },
    ],
    desglose: { reserva: [{ date: '05 Sep 2025', amount: 193000, desc: 'Pago único · reserva total' }], refunds: [] },
    units: [
      { id: 'u1', name: 'Adrián Castillo', client: 'Adrián Castillo Marin', uniqueId: null, address: null, toBeCollected: 26000, collected: 26000, collectedDate: '06 Nov 2025', status: 'Pagado', firmaEst: 'Nov 2025' },
    ]
  },
  {
    id: 'p4', name: 'San José - Xirivella', type: 'PROJECT',
    paid: 55000, toBeCollected: 45000, collected: 42500, refundPaid: 0, refundPending: 0,
    paymentDate: 'Nov 2024', collectedDate: null,
    totalUnits: 9, soldUnits: 6,
    timeline: [
      { date: '25 Jul 2024', amount: 10000, desc: '1ª tanda · reserva inicial', status: 'Pagado' },
      { date: '04 Nov 2024', amount: 45000, desc: '2ª–4ª tanda acumuladas', status: 'Pagado' },
    ],
    desglose: {
      reserva: [
        { date: '25 Jul 2024', amount: 10000, desc: '1ª tanda' },
        { date: '04 Nov 2024', amount: 45000, desc: '2ª–4ª tanda acumuladas' },
      ],
      refunds: []
    },
    units: [
      { id: 'u1', name: 'V1 - Xirivella', client: 'Ignacio de Usera', uniqueId: 'SP-THC-4QE-002390', address: 'C. San José 1, V1, Xirivella', toBeCollected: 5000, collected: 5000, collectedDate: 'Sep 2024', status: 'Pagado', firmaEst: 'Sep 2024' },
      { id: 'u9', name: 'V9 - Xirivella', client: null, uniqueId: null, address: 'C. San José 1, V9', toBeCollected: 5000, collected: 0, collectedDate: null, status: 'Sin cliente', firmaEst: null },
    ]
  },
];

const TYPE_FILTERS = ['Todos', 'PROJECT', 'BUILDING', 'UNIT', 'WIP', 'NEW BUILDING', 'VP 10%'];

function statusDotClass(status) {
  if (status === 'Pagado') return 'dot dg';
  if (status === 'Parcial') return 'dot dy';
  return 'dot dr';
}

function statusBadgeClass(status) {
  if (status === 'Pagado') return 'badge bg';
  if (status === 'Parcial') return 'badge by';
  return 'badge br';
}

function timelineStatusClass(s) {
  if (s === 'Pagado') return 'ts2 sd';
  if (s === 'Pendiente') return 'ts2 sp2';
  return 'ts2 sf';
}

function timelineDotClass(s) {
  if (s === 'Pagado') return 'td2 tdd';
  if (s === 'Pendiente') return 'td2 tdp';
  return 'td2 tdf';
}

function openBC(ref) {
  alert('Business Central\nRef: ' + ref + '\n→ En producción: enlace directo al asiento');
}

function fmtExact(n) {
  if (n === null || n === undefined || n === '') return '';
  return Number(n).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function RefundModal({ project, refundEntry, onClose, onConfirm }) {
  const clientUnits = (project.units || []).filter(u => u.client);
  const totalRefund = Math.abs(refundEntry.amount);
  const perClient = clientUnits.length > 0
    ? Math.round((totalRefund / clientUnits.length) * 100) / 100
    : 0;

  const [rows, setRows] = useState(() =>
    clientUnits.map(u => ({
      unitId: u.id,
      client: u.client,
      address: u.address || u.name,
      uniqueId: u.clientUniqueId || u.uniqueId || '—',
      amount: perClient,
    }))
  );
  const [date, setDate] = useState(refundEntry.date || new Date().toISOString().slice(0, 10));
  const [note, setNote] = useState('');

  const assigned = rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const remaining = Math.round((totalRefund - assigned) * 100) / 100;
  const isBalanced = Math.abs(remaining) < 0.01;

  const setAmount = (idx, val) => {
    setRows(prev => prev.map((r, i) => i === idx ? { ...r, amount: val } : r));
  };

  const splitEvenly = () => {
    const eq = Math.round((totalRefund / (rows.length || 1)) * 100) / 100;
    setRows(prev => prev.map(r => ({ ...r, amount: eq })));
  };

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="rm-overlay" onClick={e => { if (e.target.classList.contains('rm-overlay')) onClose(); }}>
      <div className="rm-modal">
        <div className="rm-header">
          <div>
            <div className="rm-title">Registrar pago to be refund</div>
            <div className="rm-sub">{project.name} · Total a distribuir: <strong>−{fmtExact(totalRefund)} €</strong></div>
          </div>
          <button className="rm-close" onClick={onClose}>×</button>
        </div>

        <div className="rm-meta">
          <label className="rm-label">
            Fecha del pago
            <input
              type="date"
              className="rm-input"
              value={date}
              onChange={e => setDate(e.target.value)}
            />
          </label>
          <label className="rm-label">
            Nota / referencia
            <input
              type="text"
              className="rm-input"
              placeholder="Ej. Transferencia refund firma escrituras"
              value={note}
              onChange={e => setNote(e.target.value)}
            />
          </label>
        </div>

        <div className="rm-section-title">
          Distribución por cliente
          <button className="rm-split-btn" onClick={splitEvenly}>Dividir a partes iguales</button>
        </div>

        {rows.length === 0 ? (
          <div className="rm-empty">Este proyecto no tiene clientes asignados. Asigna clientes desde HubSpot primero.</div>
        ) : (
          <div className="rm-rows">
            {rows.map((r, i) => (
              <div key={r.unitId} className="rm-row">
                <div className="rm-row-info">
                  <span className="rm-client">{r.client}</span>
                  <span className="rm-addr">{r.address}</span>
                  <span className="rm-uid">{r.uniqueId}</span>
                </div>
                <div className="rm-row-amount">
                  <input
                    type="number"
                    className={`rm-amount-input${parseFloat(r.amount) < 0 ? ' rm-neg' : ''}`}
                    value={r.amount}
                    min="0"
                    step="0.01"
                    onChange={e => setAmount(i, e.target.value)}
                  />
                  <span className="rm-currency">€</span>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className={`rm-balance${isBalanced ? ' rm-balanced' : remaining < 0 ? ' rm-over' : ' rm-under'}`}>
          <span>
            {isBalanced
              ? '✓ Importe cuadrado'
              : remaining > 0
                ? `Falta asignar: ${fmtExact(remaining)} €`
                : `Exceso: ${fmtExact(Math.abs(remaining))} € (supera el total)`
            }
          </span>
          <span className="rm-bal-detail">
            Asignado {fmtExact(assigned)} € · Total {fmtExact(totalRefund)} €
          </span>
        </div>

        <div className="rm-footer">
          <button className="rm-btn-cancel" onClick={onClose}>Cancelar</button>
          <button
            className="rm-btn-confirm"
            disabled={!isBalanced || rows.length === 0 || !date}
            onClick={() => onConfirm({ date, note, rows, refundEntry })}
          >
            <i className="ti ti-check" style={{ fontSize: 11, marginRight: 4 }}></i>
            Confirmar pago
          </button>
        </div>
      </div>
    </div>
  );
}

function VistaGeneral({ projects: airtableProjects, hsLoading, onRefundConfirm }) {
  const projects = (airtableProjects && airtableProjects.length > 0) ? airtableProjects : MOCK_PROJECTS;


  const [expandedRows, setExpandedRows] = useState(new Set(['p1']));
  const [openTimeline, setOpenTimeline]  = useState(null);
  const [timelinePanel, setTimelinePanel] = useState({});
  const [typeFilter, setTypeFilter] = useState('Todos');
  const [searchVal, setSearchVal] = useState('');
  const [refundModal, setRefundModal] = useState(null); // { project, refundEntry }
  const [toast, setToast] = useState(null);

  const toggleRow = (id) => {
    setExpandedRows(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleTimeline = (id) => {
    setOpenTimeline(prev => (prev === id ? null : id));
  };

  const switchPanel = (projId, panel) => {
    setTimelinePanel(prev => ({ ...prev, [projId]: panel }));
  };

  const getPanel = (projId) => timelinePanel[projId] || 'timeline';

  const filtered = projects.filter(p => {
    const matchType = typeFilter === 'Todos' || (p.type || '').toUpperCase() === typeFilter.toUpperCase();
    const matchSearch = !searchVal ||
      p.name.toLowerCase().includes(searchVal.toLowerCase()) ||
      (p.units || []).some(u =>
        (u.client || '').toLowerCase().includes(searchVal.toLowerCase()) ||
        (u.uniqueId || '').toLowerCase().includes(searchVal.toLowerCase())
      );
    return matchType && matchSearch;
  });

  const renderTimeline = (project) => {
    const panel = getPanel(project.id);
    const tl = project.timeline || [];
    const ds = project.desglose || { reserva: [], refunds: [] };
    return (
      <tr className="tlr">
        <td colSpan={15}>
          <div style={{ display: 'flex', gap: 0, borderBottom: '0.5px solid var(--bd)' }}>
            {/* Side panel selector */}
            <div className="tl-sidebar">
              <div
                className={`tpanel-btn${panel === 'timeline' ? ' active' : ''}`}
                onClick={() => switchPanel(project.id, 'timeline')}
              >
                <i className="ti ti-clock" style={{ fontSize: 13, color: 'var(--it)' }}></i>
                Fechas previstas
              </div>
              <div
                className={`tpanel-btn${panel === 'desglose' ? ' active' : ''}`}
                onClick={() => switchPanel(project.id, 'desglose')}
              >
                <i className="ti ti-list-details" style={{ fontSize: 13, color: 'var(--yt)' }}></i>
                Desglose pagado
              </div>
            </div>

            {/* Timeline panel */}
            {panel === 'timeline' && (
              <div className="tl-panel">
                <div className="tlt">Timeline de pagos · {project.name}</div>
                {tl.map((t, i) => (
                  <div key={i} className="ti">
                    <span className={timelineDotClass(t.status)}></span>
                    <span className="tdate">{fmtDate(t.date)}</span>
                    <span className="tamt">−{fmt(t.amount)}</span>
                    <span style={{ flex: 1 }}>{t.desc ?? t.label ?? ''}</span>
                    <span className={timelineStatusClass(t.status)}>{t.status}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Desglose panel */}
            {panel === 'desglose' && (
              <div className="tl-panel">
                <div className="tlt">Desglose de pagos realizados · {project.name}</div>
                <div className="desglose-section-title">Arras de reserva</div>
                {ds.reserva.length === 0 ? (
                  <div style={{ fontSize: 12, color: 'var(--tx3)', padding: '10px 0', fontStyle: 'italic' }}>
                    Sin pagos de arras registrados para este proyecto
                  </div>
                ) : ds.reserva.map((t, i) => (
                  <div key={i} className="ti">
                    <span className="td2 tdd"></span>
                    <span className="tdate">{fmtDate(t.date)}</span>
                    <span className="tamt">−{fmt(t.amount)}</span>
                    <span style={{ flex: 1, color: 'var(--tx2)' }}>{t.desc ?? t.label ?? ''}</span>
                    {t.ref && (
                      <span
                        className="ts2"
                        style={{ cursor: 'pointer', color: 'var(--it)', borderColor: 'var(--it)' }}
                        onClick={() => openBC(t.ref)}
                        title={`Asiento BC: ${t.ref}`}
                      >
                        {t.ref} <i className="ti ti-external-link" style={{ fontSize: 9 }}></i>
                      </span>
                    )}
                    <span className="ts2 sd">Arras reserva</span>
                  </div>
                ))}
                <div className="desglose-section-title" style={{ marginTop: 14 }}>Arras to be refund pagadas</div>
                {ds.refunds.length === 0 ? (
                  <div style={{ fontSize: 12, color: 'var(--tx3)', padding: '10px 0', fontStyle: 'italic' }}>
                    Sin pagos de refund registrados para este proyecto
                  </div>
                ) : ds.refunds.map((t, i) => (
                  <div key={i} style={{ marginBottom: 4 }}>
                    <div className="ti" style={{ background: 'var(--ys)', borderRadius: t.breakdown ? '6px 6px 0 0' : 6, padding: '6px 8px' }}>
                      <span className="td2" style={{ background: 'var(--yt)', borderRadius: '50%' }}></span>
                      <span className="tdate">{fmtDate(t.date)}</span>
                      <span className="tamt" style={{ color: 'var(--yt)' }}>−{fmt(t.amount)}</span>
                      <span style={{ flex: 1, color: 'var(--tx2)' }}>{t.desc ?? t.label ?? ''}</span>
                      {t.ref && (
                        <span
                          className="ts2"
                          style={{ cursor: 'pointer', color: 'var(--it)', borderColor: 'var(--it)' }}
                          onClick={() => openBC(t.ref)}
                          title={`Asiento BC: ${t.ref}`}
                        >
                          {t.ref} <i className="ti ti-external-link" style={{ fontSize: 9 }}></i>
                        </span>
                      )}
                      <span className="ts2" style={{ background: 'var(--ys)', color: 'var(--yt)', borderColor: 'var(--yt)' }}>
                        {t.manual ? 'Manual' : 'BC'} · Refund pagado
                      </span>
                    </div>
                    {t.breakdown && t.breakdown.length > 0 && (
                      <div style={{ background: '#fefae8', border: '0.5px solid var(--bd)', borderTop: 'none', borderRadius: '0 0 6px 6px', padding: '4px 8px 6px 28px' }}>
                        {t.breakdown.map((r, ri) => (
                          <div key={ri} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 10.5, color: 'var(--tx2)', padding: '2px 0' }}>
                            <span style={{ fontWeight: 500, color: 'var(--tx)' }}>{r.client}</span>
                            <span style={{ color: 'var(--tx3)' }}>{r.address}</span>
                            <span style={{ marginLeft: 'auto', fontWeight: 500, color: 'var(--yt)' }}>−{fmtExact(r.amount)} €</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                <button
                  className="asb"
                  style={{ marginTop: 8 }}
                  onClick={() => {
                    const lastRefund = ds.refunds.length > 0 ? ds.refunds[ds.refunds.length - 1] : null;
                    const entry = lastRefund ?? { amount: -(project.arrasPageadas || 0), date: null, desc: '' };
                    setRefundModal({ project, refundEntry: entry });
                  }}
                >
                  <i className="ti ti-plus" style={{ fontSize: 10, marginRight: 4 }}></i>
                  Registrar pago to be refund
                </button>
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div>
      {/* Filters */}
      <div className="filters">
        <span className="fl">Tipo:</span>
        {TYPE_FILTERS.map(f => (
          <button
            key={f}
            className={`fb${typeFilter === f ? ' active' : ''}`}
            onClick={() => setTypeFilter(f)}
          >
            {f}
          </button>
        ))}
        <div style={{ flex: 1 }}></div>
        <div className="search-box">
          <i className="ti ti-search"></i>
          <input
            type="text"
            placeholder="Buscar proyecto, cliente, ID..."
            value={searchVal}
            onChange={e => setSearchVal(e.target.value)}
          />
        </div>
      </div>

      {/* Table */}
      <div className="tw">
        <table id="main-table">
          <thead>
            <tr>
              <th rowSpan={2}>Proyecto / unidad</th>
              <th rowSpan={2}>Tipo</th>
              <th rowSpan={2}>Cliente</th>
              <th rowSpan={2}>Unique ID</th>
              <th rowSpan={2}>Dirección</th>
              <th rowSpan={2} className="cs">
                Arras pagadas<br />
                <span style={{ fontWeight: 400, color: 'var(--tx3)' }}>(supply→vendedor)</span>
              </th>
              <th rowSpan={2} className="cs">
                Fecha pago<br />
                <span style={{ fontWeight: 400, color: 'var(--tx3)' }}>(BC)</span>
              </th>
              <th colSpan={3} className="gh gc cs">Cobros de clientes</th>
              <th rowSpan={2} className="cs">
                Fecha cobro<br />
                <span style={{ fontWeight: 400, color: 'var(--tx3)' }}>(BC)</span>
              </th>
              <th rowSpan={2} className="cs">
                Arras to be refund<br />
                <span style={{ fontWeight: 400, color: 'var(--tx3)' }}>(pagado al vendedor)</span>
              </th>
              <th rowSpan={2}>Net position<br /><span style={{ fontWeight: 400, color: 'var(--tx3)' }}>(solo proyecto)</span></th>
              <th rowSpan={2}>Firma est.</th>
              <th rowSpan={2}>Estado</th>
            </tr>
            <tr>
              <th className="sh cs">
                To be collected<br />
                <span style={{ fontWeight: 400, fontStyle: 'italic' }}>(Vistral)</span>
              </th>
              <th className="sh">
                Collected<br />
                <span style={{ fontWeight: 400, fontStyle: 'italic' }}>(real·BC)</span>
              </th>
              <th className="sh">Diferencia</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(project => {
              const isExpanded = expandedRows.has(project.id);
              const isTimelineOpen = openTimeline === project.id;
              const paid = project.arrasPageadas || project.paid || 0;
              const netPos = paid - (project.collected || 0);
              const diff = (project.collected || 0) - (project.toBeCollected || 0);

              return (
                <React.Fragment key={project.id}>
                  {/* Project row */}
                  <tr className="pr" onClick={() => toggleRow(project.id)}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span
                          className="chevron-icon"
                          style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}
                        >›</span>
                        <div>
                          <div>{project.name}</div>
                          {(project.operationName || project.uniqueId) && (
                            <div style={{ fontSize: 10, color: 'var(--tx3)', marginTop: 1 }}>
                              {[project.operationName, project.uniqueId].filter(Boolean).join(' · ')}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td><span className="tag">{project.type || 'PROJECT'}</span></td>
                    <td style={{ color: 'var(--tx3)' }}>—</td>
                    <td style={{ color: 'var(--tx3)' }}>—</td>
                    <td style={{ color: 'var(--tx3)' }}>—</td>
                    <td className="cs">
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <button
                          className="ab"
                          style={{ fontSize: 10, padding: '2px 7px', gap: 3 }}
                          onClick={e => { e.stopPropagation(); toggleTimeline(project.id); if (openTimeline !== project.id) switchPanel(project.id, 'timeline'); }}
                        >
                          <i className="ti ti-clock" style={{ fontSize: 10 }}></i>Fechas
                        </button>
                        <button
                          className="ab"
                          style={{ fontSize: 10, padding: '2px 7px', gap: 3, color: 'var(--yt)', borderColor: 'var(--yt)' }}
                          onClick={e => { e.stopPropagation(); toggleTimeline(project.id); if (openTimeline !== project.id) switchPanel(project.id, 'desglose'); }}
                        >
                          <i className="ti ti-list-details" style={{ fontSize: 10 }}></i>
                          {hsLoading ? <Skeleton /> : `−${fmt(paid)}`}
                        </button>
                      </div>
                    </td>
                    <td className="cs" style={{ color: 'var(--tx2)', fontSize: 11 }}>
                      {fmtDate(project.paymentDate || (() => {
                        const tl = project.timeline || [];
                        return [...tl].reverse().find(t => t.date)?.date ?? null;
                      })())}
                    </td>
                    <td className="cs" style={{ fontWeight: 500 }}>
                      {hsLoading ? <Skeleton /> : fmt(project.toBeCollected || 0)}
                    </td>
                    <td className={!hsLoading && (project.collected || 0) >= (project.toBeCollected || 0) ? 'np' : 'nw'}>
                      {hsLoading ? <Skeleton /> : `${(project.collected || 0) >= (project.toBeCollected || 0) ? '+' : ''}${fmt(project.collected || 0)}`}
                    </td>
                    <td className={!hsLoading && (diff < 0 ? 'nn' : diff > 0 ? 'np' : '')}>
                      {hsLoading ? <Skeleton /> : `${diff < 0 ? '−' : diff > 0 ? '+' : ''}${fmt(Math.abs(diff))}`}
                    </td>
                    <td className="cs" style={{ color: 'var(--tx2)', fontSize: 11 }}>—</td>
                    <td className="cs" style={{ color: 'var(--yt)', fontWeight: 500 }}>
                      {hsLoading ? <Skeleton /> : (project.refundPending ? `${fmt(project.refundPending)} total` : '—')}
                    </td>
                    <td className={!hsLoading && (netPos > 0 ? 'nn' : 'np')}>
                      {hsLoading ? <Skeleton /> : `${netPos > 0 ? '−' : '+'}${fmt(Math.abs(netPos))}`}
                    </td>
                    <td style={{ color: 'var(--tx3)' }}>—</td>
                    <td>
                      <span className="badge by">{project.soldUnits}/{project.totalUnits}</span>
                    </td>
                  </tr>

                  {/* Timeline row */}
                  {isTimelineOpen && renderTimeline(project)}

                  {/* Unit rows */}
                  {isExpanded && (project.units || []).map(unit => {
                    const uDiff = unit.collected - unit.toBeCollected;
                    return (
                      <tr key={unit.id} className="ur">
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span className={statusDotClass(unit.status)}></span>
                            <div>
                              {unit.client ? (
                                <span className="bcl" onClick={() => openBC(unit.hsUniqueId || unit.uniqueId || unit.client)}>
                                  {unit.client}
                                  <i className="ti ti-external-link" style={{ fontSize: 10 }}></i>
                                </span>
                              ) : hsLoading ? (
                                <span style={{ color: 'var(--tx3)', fontStyle: 'italic' }}>Cargando…</span>
                              ) : (
                                <span style={{ color: 'var(--tx3)' }}>Sin asignar</span>
                              )}
                              <div style={{ fontSize: 10, color: 'var(--tx3)', marginTop: 1 }}>{unit.name}</div>
                            </div>
                          </div>
                        </td>
                        <td><span className="tag">UNIT</span></td>
                        <td>
                          {unit.client ? (
                            <span className="bcl" onClick={() => openBC(unit.hsUniqueId || unit.uniqueId || unit.client)}>
                              {unit.client}
                              <i className="ti ti-external-link" style={{ fontSize: 10 }}></i>
                            </span>
                          ) : hsLoading ? (
                            <span style={{ color: 'var(--tx3)', fontStyle: 'italic' }}>Cargando…</span>
                          ) : (
                            <span style={{ color: 'var(--tx3)' }}>Sin asignar</span>
                          )}
                        </td>
                        <td style={{ fontSize: 10, color: 'var(--tx2)' }}>
                          {unit.clientUniqueId || '—'}
                        </td>
                        <td>
                          {unit.address ? (
                            <div className="addr">{unit.address}</div>
                          ) : (
                            <span style={{ color: 'var(--tx3)' }}>—</span>
                          )}
                        </td>
                        <td className="cs ec">—</td>
                        <td className="cs" style={{ fontSize: 11, color: 'var(--tx2)' }}>—</td>
                        <td className="cs">
                          {hsLoading ? <Skeleton /> : fmt(unit.toBeCollected)}
                        </td>
                        <td className={!hsLoading && (uDiff >= 0 ? 'np' : 'nw')}>
                          {hsLoading ? <Skeleton /> : `${uDiff >= 0 ? '+' : ''}${fmt(unit.collected)}${uDiff === 0 ? ' ✓' : ''}`}
                        </td>
                        <td className={!hsLoading && (uDiff < 0 ? 'nn' : uDiff > 0 ? 'np' : '')}>
                          {hsLoading ? <Skeleton /> : (uDiff === 0 ? '€0' : (uDiff < 0 ? '−' : '+') + fmt(Math.abs(uDiff)))}
                        </td>
                        <td className="cs" style={{ fontSize: 11, color: 'var(--tx2)' }}>
                          {hsLoading ? '—' : fmtDate(unit.collectedDate)}
                        </td>
                        <td className="cs">
                          {hsLoading ? <Skeleton /> : unit.refundPaid > 0 ? (
                            <span style={{ color: 'var(--yt)', fontWeight: 500, fontSize: 11 }}>
                              −{fmt(unit.refundPaid)}
                            </span>
                          ) : (
                            <span style={{ fontSize: 10, color: 'var(--tx3)' }}>Pendiente</span>
                          )}
                        </td>
                        <td className="ec">—</td>
                        <td>{unit.firmaEst || <span style={{ color: 'var(--tx3)' }}>—</span>}</td>
                        <td><span className={statusBadgeClass(unit.status)}>{unit.status}</span></td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div className="legend">
        <div className="li2"><strong>Net position</strong> — solo en fila de proyecto</div>
        <div className="li2">
          <strong>Nombre cliente</strong> — enlace directo a BC{' '}
          <i className="ti ti-external-link" style={{ fontSize: 10, color: 'var(--it)' }}></i>
        </div>
        <div className="li2"><strong style={{ color: 'var(--rt)' }}>−€ arras pagadas</strong> — clic para ver timeline de tandas</div>
        <div className="li2">
          <span className="dot dg" style={{ marginRight: 3 }}></span>Verde = pagado ·{' '}
          <span className="dot dy" style={{ marginRight: 3, marginLeft: 6 }}></span>Amarillo = parcial ·{' '}
          <span className="dot dr" style={{ marginRight: 3, marginLeft: 6 }}></span>Rojo = sin cliente
        </div>
      </div>

      {/* Refund modal */}
      {refundModal && (
        <RefundModal
          project={refundModal.project}
          refundEntry={refundModal.refundEntry}
          onClose={() => setRefundModal(null)}
          onConfirm={({ date, note, rows }) => {
            if (onRefundConfirm) {
              onRefundConfirm({ projectId: refundModal.project.id, date, note, rows });
            }
            setRefundModal(null);
            const total = rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
            setToast(`Refund registrado · −${fmtExact(total)} € distribuido entre ${rows.length} cliente${rows.length !== 1 ? 's' : ''}`);
            setTimeout(() => setToast(null), 4000);
          }}
        />
      )}

      {/* Toast */}
      {toast && (
        <div className="rm-toast">
          <i className="ti ti-circle-check" style={{ fontSize: 14 }}></i>
          {toast}
        </div>
      )}
    </div>
  );
}

export default VistaGeneral;
